import React, { useState } from "react";

const ImageUploadModal = ({
  show,
  onHide,
  onImageUpload,
  defaultImage = "/assets/images/default-package.jpg",
  title = "Upload Image",
  aspectRatio = "1/1", // Default to square, can be overridden
}) => {
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file type
      if (!file.type.startsWith("image/")) {
        alert("Please select an image file");
        return;
      }

      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert("Please select an image smaller than 5MB");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setImageFile(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    if (imageFile) {
      onImageUpload(imageFile, imagePreview);
    } else {
      // Use default image if no image is selected
      onImageUpload(null, defaultImage);
    }
    onHide();
    // Reset state for next use
    setImagePreview(null);
    setImageFile(null);
  };

  const handleClose = () => {
    onHide();
    // Reset state for next use
    setImagePreview(null);
    setImageFile(null);
  };

  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <div
              className="image-box mb-3"
              style={{
                width: "100%",
                aspectRatio: aspectRatio,
                border: "2px dashed #ccc",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "#f8f9fa",
                margin: "0 auto",
              }}
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Upload Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <img
                  src={defaultImage}
                  alt="Default"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}
            </div>
            <input
              id="modalImageUpload"
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="form-control d-none"
            />
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() =>
                document.getElementById("modalImageUpload").click()
              }
            >
              <i className="ri-upload-line me-1"></i> Select Image
            </button>
            <div className="mt-2 text-muted small">
              Supported formats: JPG, PNG, GIF. Max size: 5MB
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {imageFile ? "Upload Image" : "Use Default Image"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadModal;
